export enum  FormItemType {
  INPUT_TEXT = 'text',
  INPUT_NUMBER = 'number',
  CHECKBOX = 'checkbox',
  DATE_PICKER = 'date_picker',
  SELECT = 'select',
  TEXTAREA = 'text_area',
  DATE_TIME_PICKER = 'date_time_picker',
  DATE_TIME_RANGE_PICKER = 'date_time_range_picker',
  DATE_RANGE_PICKER = 'date_range_picker',
  RANGE_NUMBER = 'range_number',
  TAGS = 'tags',
}
